




















































































































































































































































































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ConsumerApplication, ConsumerApplicationStatus, ConsumerApplicationResponse } from '@/store/consumer-application/types';
import { FinancialInstitution } from '@/store/financial-institution/types';
const VMask = require('v-mask').default;
Vue.use(VMask);

const namespace = 'consumerApplication';
const fiNamespace = 'financialInstitution';

const DECLINED_HEADER = 'Unfortunately, we cannot offer you a Kasasa Edge World Mastercard Credit Card at this time. Please expect a letter in' +
									' the mail with further details about the credit decision. Your application is over, and you can safely close your browser window.'

@Component({
	name: 'credit-card-application-complete',
})
export default class ApplicationComplete extends Vue {
    @Prop({required: true }) applicationStep!: number;
	@Getter('processingStatus', { namespace }) processingStatus?: ConsumerApplicationStatus;
	@Getter('consumerApplication', { namespace }) consumerApplication?: ConsumerApplication;
	@Getter('consumerApplicationResponse', { namespace }) consumerApplicationResponse?: ConsumerApplicationResponse;
	@Getter('maskedSSN', { namespace }) maskedSSN?: string;
	@Getter('fiCompany', { namespace:fiNamespace }) fiCompany?: FinancialInstitution;


	data() {
		return {
			status: ConsumerApplicationStatus.NONE,
			creditAmount: 0,
			creditApr: 0,
			declineDialog: false,
			upgradedAccount: false,
			upgradeDeclined: false,
			declinedHeader: DECLINED_HEADER,
		};
	}

	@Watch('processingStatus')
	applicationComplete(){
		this.$data.status = this.processingStatus;
	}

	upgradeChecking(){
		const button = document.getElementById('continue-to-upgrade-button');
		if (button != null) {
			button.classList.remove('accept-button');
			button.classList.add('accept-button-disabled-button-after-click');
		}				
		this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_STATUS', ConsumerApplicationStatus.UPGRADING );
	}

	submitUpgrade(){
		const button = document.getElementById('accept-upgrade-buttona');
		if (button != null) {
			button.classList.remove('accept-button');
			button.classList.add('accept-button-disabled-button-after-click');
		}		
		this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_STATUS', ConsumerApplicationStatus.UPGRADE_SUBMITTED );
		this.$data.upgradedAccount = true;
		this.$store.commit('consumerApplication/SET_ACCOUNT_CONVERSION_STATUS', true );
		if(this.consumerApplication?.candidate?.reservationCode != undefined){
			this.$store.dispatch('consumerApplication/updateAccountConversionStatus', this.consumerApplication.candidate.reservationCode);
		}
	}

	declineUpgrade(){
		this.$store.commit('consumerApplication/SET_CONSUMER_APPLICATION_STATUS', ConsumerApplicationStatus.DECLINE_SUBMITTED );
		this.$data.declineDialog = false;
		this.$store.commit('consumerApplication/SET_ACCOUNT_CONVERSION_STATUS', false );
		if(this.consumerApplication?.candidate?.reservationCode != undefined){
			this.$store.dispatch('consumerApplication/updateAccountConversionStatus', this.consumerApplication.candidate.reservationCode).then( () => {
				this.$data.upgradeDeclined = true;
			});
		}
	}

	computed() {
		this.fiCompany;
		
	}
}
